import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import DealersRoleDetail from './components/DealersRoleDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageDealersRole',
  components: {
    DealersRoleDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;